import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import loc from 'owa-localize';
import NoteEdit from 'owa-fluent-icons-svg/lib/icons/NoteEditRegular';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { createMailAppFlyoutAnchor } from '../../../util/createMailRibbonButton';
import { MailRibbonGroupId, MailRibbonTabId } from 'owa-ribbon-ids';
import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { RibbonFlyoutAnchorProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRNotesTabCommonGroupFlyout = computedFn(
    (
        groupId: RibbonGroupId,
        popoutComposeViewState?: ComposeViewState
    ): RibbonFlyoutAnchorProps | undefined => {
        switch (groupId) {
            case MailRibbonGroupId.Group_Notes_Edit:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.notes_GroupEdit),
                    undefined /*tooltip*/,
                    false /*isPopout*/,
                    emptyMenuDefinition,
                    constructKeytip(
                        [getKeytipString(MailRibbonTabId.Tab_Notes)],
                        getKeytipString(MailRibbonGroupId.Group_Notes_Edit)
                    ),
                    NoteEdit
                );

            default:
                return undefined;
        }
    }
);
